module.exports = __webpack_public_path__ + "h5/img/404.d0e4612e.gif";